import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import Layout from '../../../layouts'
import LargeHero from '../../../components/elements/largeHero'
import { Body, SizedText, Canon } from '../../../components/elements/typography'
import Grid from '../../../components/elements/grid'
import ExternalLink from '../../../components/elements/externalLink'
import PoliciesMenu from "../../../components/molocules/menus/policiesMenu"
import SEO from '../../../components/elements/seo'


const FDICCoveragePage = ({}) => {

  return (
    <Layout isSubMenuOpen={true} openAccountLink={true}>

      <SEO
        title="FDIC Coverage | TCB Trust Center"
        description="Your The Claxton Bank deposits are fully protected up to the standard deposit insurance amount by the Federal Deposit Insurance Corporation (FDIC). Lean how to maximize your coverage."
        location="/about/policies/fdic-coverage"
        ogImg='/images/social-graph/the-claxton-bank.jpg'
      />  

      <LargeHero.Container
        padding="3rem 0 4rem 0"
        background={{
          //backgroundColor: `#b2a08a`,
          backgroundImage: `url(/images/background-deltas.jpg)`, 
          backgroundRepeat: `no-repeat`, 
          backgroundAttachment: `scroll`, 
          backgroundPosition: `top left`, 
          backgroundSize: `cover`,
        }}
        breadcrumbLinks={[
          { path: "/", text: "Home" },
          { path: "/about/", text: "About Us" },
          { path: "/about/policies/", text: "Policies" },
          { path: "/about/policies/fdic-coverage", text: "FDIC Coverage" }
        ]}
        styles={{
          paddingBottom: `5rem`,
          overflow: `hidden`,
          '.breadcrumbs, .breadcrumbs [aria-current="page"]': {color: `#fff`},
          '.heroContent': { paddingBottom: `3rem`},
          '@media (min-width: 680px)': {
            '.heroContent': { width: `calc(72% - 1rem)`, marginBottom: `0`},
            '.heroImage': { width: `calc(40% - 1rem) !important`,},
          }
        }}
      >
        <LargeHero.Content styles={{paddingTop: `1rem`, color: `#fff`}}>
          <LargeHero.Eyebrow text="Policies & Disclosures" styles={{borderColor: `#fff !important`}}/>
          <h1 css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`,  'span': {display: `block`, lineHeight: `1`, padding: `0.5rem 0`}}}>
            <SizedText as="span" smallSize="2.281" largeSize="4.624">FDIC Coverage</SizedText>
          </h1>
        </LargeHero.Content>
        <LargeHero.Image >
          <StaticImage 
              css={{
                '@media (min-width: 680px)': { display: 'none !important' }, 
                '@media (min-width: 1300px)': { display: 'block !important' } 
              }} 
              src="../../../images/policies.png" 
              alt=""
            />
            <StaticImage 
              css={{
                display: `none !important`,  
                '@media (min-width: 680px)': { display: 'block !important' }, 
                '@media (min-width: 1300px)': { display: 'none !important' } 
              }} 
              src="../../../images/policies_cropped.png" 
              alt=""
            />
        </LargeHero.Image>
      </LargeHero.Container>

      <Grid.FullWidthSection>
        <Grid.Block start={[2,2,2,2,2,2,3]} span={[12,12,12,12,8,8,7]} css={{
          paddingBottom: `4rem`,
          'p': {textAlign: `justify`, color: "#707070"},
          'h1': {color: `#1d449e`, margin: `0`, padding: `4rem 0 2rem 0`},
          'h2': { marginTop: `2rem`, color: `#3498db`, fontFamily: `proxima-nova`},
          'h3': { padding: `2rem 0 1rem 0`}
        }}>
          <SizedText as="p" smallSize="1" largeSize="1.125" css={{padding: `4rem 0 0 0`, lineHeight: '1.5 !important'}}>
            We know that you want to be sure that your money is safe and secure, and that you may have questions about how your money is insured.  
            You can rest easy, because The Claxton Bank is a member of the Federal Deposit Insurance Corporation, or FDIC for short, which insures 
            each depositor at TCB up to $250,000.00 (and possibly more).  Our top two priorities are providing a premier banking experience and securing 
            your money, which is why we constantly monitor updates and changes to legislation and FDIC coverage, and share those changes with  
            you and our employees as soon as possible.  
          </SizedText>


            <Canon>What is the FDIC</Canon>
            <Body>
              The Federal Deposit Insurance Corporation, or FDIC, is an independent agency of the United States government that was established by 
              Congress with a mission to insure bank deposits, and protect your money in the event that an FDIC insured bank fails.  The FDIC is backed by 
              the full faith and credit of the U.S. Treasury, and deposits are also protected by the financial strength and stability of The Claxton Bank, 
              which has been serving the needs of individuals and businesses since 1941. Since the FDIC was established in 1933, “no depositor has ever 
              lost a penny of their FDIC-insured deposits.”<sup>1</sup> You can feel confident, knowing that your insured deposits at The Claxton Bank are protected.
            </Body>

            <Canon>What the FDIC Protects</Canon>
            <Body>
              Your TCB deposits are fully protected up to the standard deposit insurance amount set by the Federal Deposit Insurance Corporation (FDIC). 
              This full coverage remains in place even during periods of government shutdown since the FDIC is funded through assessments on insured 
              institutions, not through appropriated funds. The standard deposit insurance amount is $250,000 per depositor, per insured bank, for each 
              account ownership category. The FDIC provides separate insurance coverage for deposit accounts held in different categories of ownership. 
              You may qualify for more than $250,000 in coverage at one insured bank if you own deposit accounts in different categories. 
            </Body>

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              What types of accounts are covered by the FDIC?
            </SizedText>
            <Body>
              FDIC insured accounts include checking and savings accounts, money market deposit accounts, CDs and deposits in IRAs. The FDIC does not insure 
              money invested in non-deposit investment products, such as stocks, bonds, mutual funds, life insurance policies, annuities or municipal securities, 
              even if these investments were bought from an insured bank. The FDIC does not insure U.S. Treasury bills, bonds, or notes. The table below can help 
              you determine if your TCB account is covered by FDIC insurance or not.
            </Body>

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              How much does the FDIC cover?
            </SizedText>
            <Body>
              The standard FDIC coverage amount is up to $250,000 per depositor, per insured bank, for each account ownership category. If you have joint deposit 
              accounts, you and the other account co-owner(s) are covered up to $250,000 each in the joint account ownership category. Your share of each joint 
              account on which you are an owner will be added together to determine this coverage.
            </Body>

            <SizedText as="h3" smallSize="1.125" largeSize="1.266" css={{paddingBottom: `1rem`}}>
              Individual Accounts
            </SizedText>
            <Body>
              Individual accounts are accounts owned by one person and titled in that person's name only. All individual accounts at the same insured bank are 
              added together and the total is insured up to $250,000. So for example if you have a checking account and a CD at the same bank, both in your name 
              only, the two accounts are added together and insured up to $250,000.  Individual accounts include: Single ownership accounts, Sole proprietorship 
              accounts, Agent, custodian, conservator accounts, UTMA accounts, Estate accounts.
            </Body>

            <SizedText as="h3" smallSize="1.125" largeSize="1.266" css={{paddingBottom: `1rem`}}>
              Joint Accounts
            </SizedText>
            <Body>
              Each person is entitled to a maximum of $250,000 coverage for deposits in all of their joint accounts in addition to individual insured accounts.  
              So if a couple shares a joint checking and savings account at the same insured bank, each co-owners shares of the two accounts are added together 
              and insured up to $250,000, effectively providing up to $500,000 in coverage for the couples accounts.  
            </Body>

            <SizedText as="h3" smallSize="1.125" largeSize="1.266" css={{paddingBottom: `1rem`}}>
              Retirement Accounts
            </SizedText>
            <Body>
              Some types of retirement accounts are insured separately from other individually owned deposits a customer has at the same FDIC insured bank, titled 
              in the same name.  Only Individual Retirement Accounts (including traditional IRAs, Roth IRAs, Simplified Employee Pension (SEP) IRAs, and Savings 
              Incentive Match Plans for Employees (SIMPLE) IRAs), Section 457 deferred compensation plan accounts (whether self-directed or not), Self-directed 
              defined contribution plan accounts, Self-directed Keogh plan (or H.R. 10 plan) accounts are insured in this ownership category.  All deposits that a 
              customer has in these types of retirement plans are added together and insured up to $250,000.  Please note: Naming beneficiaries on a retirement 
              account does not increase deposit insurance coverage.
            </Body>

            <SizedText as="h3" smallSize="1.125" largeSize="1.266" css={{paddingBottom: `1rem`}}>
              Business Accounts
            </SizedText>
            <Body>
              In general, business accounts receive $250,000 in FDIC insurance. This includes municipalities. Please note, however, that funds owned by a business 
              that is a sole proprietorship are NOT insured under this category. Rather, they are insured as the single account funds of the person who is the sole proprietor.
            </Body>

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Notice of Changes in Coverage
            </SizedText>
            <Body>
              By operation of federal law, beginning January 1, 2013, funds deposited in a noninterest-bearing transaction account (including an Interest on Lawyer Trust Account) 
              no longer will receive unlimited deposit insurance coverage by the Federal Deposit Insurance Corporation (FDIC). Beginning January 1, 2013, all of a depositor's 
              accounts at an insured depository institution, including all noninterest-bearing transaction accounts, will be insured by the FDIC up to the standard maximum deposit 
              insurance amount ($250,000), for each deposit insurance ownership category.
            </Body>

            <Canon>Additional Tools and Information</Canon>
            <Body>
              The scenarios above are an example of how FDIC insurance works, and what we’re showing you isn’t legal, tax, investment or financial advice. If you have questions 
              about FDIC insurance, consult a financial professional or go to <ExternalLink to="https://www.fdic.gov/deposit/deposits">https://www.fdic.gov/deposit/deposits</ExternalLink> &nbsp;
              for more details. For additional FDIC insurance information, we encourage you to visit the FDIC online or call 1-877-ASK-FDIC (1-877-275-3342) Monday–Friday 
              8:00 a.m.–8:00 p.m. ET or call The Claxton Bank Directly at 912-739-3322.
            </Body>
        </Grid.Block>
        <Grid.Block start={[2,2,2,2,10,10]} span={[12,12,12,12,4,3]}
          css={{ 
            margin: `4rem 0`,
        }}>
          
          <PoliciesMenu />
        </Grid.Block>
      </Grid.FullWidthSection>
    </Layout> 
  )
}

export default FDICCoveragePage
